<template>
    <div id="cliente-cadastro">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                 <TituloPagina class="header ml-2" titulo="Editar evento" />
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <div class="row">
                                <div class="col m8">
                                    <!-- <h4 class="header">Editar evento</h4> -->
                                </div>
                                <div class="col m4">
                                    <button
                                        class="ml-2 btn right"
                                        @click="removeAgenda()">
                                        Excluir evento
                                        <i class="material-icons right">delete</i>
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-agenda v-if="showForm" @newdata="handleDataEmpresa($event)" :agenda="formData"></formulario-agenda>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import { get, put, remove } from '@/helpers/api';
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, CORRETOR } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import FormularioAgenda from './Formulario';
    import Message from '@/helpers/message';
    import swal from 'sweetalert2';
    import TituloPagina from '@/components/common/TituloPagina';

    export default {
        components: {
            MaskedInput,
            FormularioAgenda,
            TituloPagina
        },
        data: () => ({
            formData: {
                agenda_id: '',
                agenda_nome: '',
                agenda_data: '',
                agenda_hora: '',
                funcionario_id: '',
                agenda_endereco: '',
                agenda_endereco_latitude: '',
                agenda_endereco_longitude: '',
                agenda_descricao: '',
                agenda_data_fim: '',
                agenda_hora_fim: '',
                notificar_minutos_antes: '',
            },
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            showForm: false
        }),
        created() {
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;

            let self = this;
            get('agenda/'+this.$route.params.id).then(function (response) {
                let agenda = response.data.result.data;
                self.formData.agenda_nome = agenda.agenda_nome;
                self.formData.agenda_data = agenda.agenda_data;
                self.formData.funcionario_id = agenda.funcionario_id;
                self.formData.agenda_id = agenda.agenda_id;
                self.formData.agenda_endereco = agenda.agenda_endereco;
                self.formData.agenda_endereco_latitude = agenda.agenda_endereco_latitude;
                self.formData.agenda_endereco_longitude = agenda.agenda_endereco_longitude;
                self.formData.agenda_descricao = agenda.agenda_descricao;
                self.formData.agenda_data_fim = agenda.agenda_data_fim;
                self.formData.agenda_hora_fim = agenda.agenda_hora_fim;
                self.formData.notificar_minutos_antes = agenda.notificar_minutos_antes;
                self.showForm = true;
            });
        },
        methods: {
            save() {
                if (
                        this.formData.agenda_nome == '' ||
                        this.formData.agenda_data == '' ||
                        this.formData.agenda_hora == '' ||
                        this.formData.funcionario_id == '' ||
                        // this.formData.agenda_endereco == '' ||
                        // this.formData.agenda_endereco_latitude == '' ||
                        // this.formData.agenda_endereco_longitude == '' ||
                        // this.formData.agenda_descricao == '' ||
                        this.formData.agenda_data_fim == '' ||
                        this.formData.agenda_hora_fim== ''){
                            Message.messageError('Todos os campos são obrigatórios');
                            return;
                        }
                let self = this;

                put('agenda/'+this.formData.agenda_id, {
                    agenda_nome: this.formData.agenda_nome,
                    agenda_data: this.formData.agenda_data,
                    agenda_hora: this.formData.agenda_hora,
                    funcionario_id: this.formData.funcionario_id,
                    agenda_endereco: this.formData.agenda_endereco,
                    agenda_endereco_latitude: this.formData.agenda_endereco_latitude,
                    agenda_endereco_longitude: this.formData.agenda_endereco_longitude,
                    agenda_descricao: this.formData.agenda_descricao,
                    agenda_data_fim: this.formData.agenda_data_fim,
                    agenda_hora_fim: this.formData.agenda_hora_fim,
                    notificar_minutos_antes: this.formData.notificar_minutos_antes,
                }).then(function (response) {

                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/');

                }).catch(function () {
                    Message.messageError('Verifique se todos os campos foram preenchidos.');
                })
            },
            handleDataEmpresa(e) {
                [
                    this.formData.agenda_nome,
                    this.formData.agenda_data,
                    this.formData.agenda_hora,
                    this.formData.funcionario_id,
                    this.formData.agenda_endereco,
                    this.formData.agenda_endereco_latitude,
                    this.formData.agenda_endereco_longitude,
                    this.formData.agenda_descricao,
                    this.formData.agenda_data_fim,
                    this.formData.agenda_hora_fim,
                    this.formData.notificar_minutos_antes,
                ] = e;
            },
            removeAgenda() {
                let self = this;
                swal({
                    title: 'Tem certeza que deseja remover esse evento?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        remove('agenda/remove-agenda-avulsa/'+this.formData.agenda_id)
                            .then(function (response) {
                                swal(
                                    'Retirado com sucesso.',
                                    '',
                                    'success'
                                );

                                self.$router.push('/');
                            });
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/agenda/Editar.vue